import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerAltriLibriModalComponent } from './worker-altri-libri-modal';

export const WorkerAltriLibriModalModule: string = ng
    .module('worker-altri-libri-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerAltriLibriModalComponent', WorkerAltriLibriModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-altri-libri-modal/worker-altri-libri-modal.module.ts